
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { OperationInfo, PermissionCode, User } from '@/types';
import LeadCategoriesAndTags from '@/components/LeadCategoriesAndTags.vue';
import EditLeadDetailsDialog from '@/components/EditLeadDetailsDialog.vue';
import { currentUserHasPermission } from '@/helpers';

@Component({
  components: {
    LeadCategoriesAndTags,
    EditLeadDetailsDialog,
  },
})
export default class OperationTags extends Vue {
  @Prop(Object) readonly operationInfo: OperationInfo | undefined;
  @Prop(String) readonly pageSource: string | undefined;

  editDialog = false

  hasPermission(codename: PermissionCode): boolean { return currentUserHasPermission(codename); }

  @Watch('editDialog')
  onEditDialogChange(val: boolean) {
    // Se è stato chiuso il dialog, emette l'evento "close"
    if (val === false) {
      this.$emit('close');
    }
  }

  get user(): User {
    return this.$store.getters.currentUser;
  }

  get operationAllowedUsers(): number[] {
    if (!this.operationInfo?.allowedUsers) return [];
    const parsed = this.operationInfo.allowedUsers.substring(1, this.operationInfo.allowedUsers.length - 1).split(':')
      .map((s: string) => Number(s))
      .filter((n: number) => !Number.isNaN(n));
    return parsed;
  }

  get fatherAllowedUsers(): number[] {
    // Se non è disponibile fatherAllowedUsers, usa allowedUsers (retrocompatibilità)
    const allowedUsersString = this.operationInfo?.fatherAllowedUsers || this.operationInfo?.allowedUsers;
    if (!allowedUsersString) return [];
    const parsed = allowedUsersString.substring(1, allowedUsersString.length - 1).split(':')
      .map((s: string) => Number(s))
      .filter((n: number) => !Number.isNaN(n));
    return parsed;
  }

  get isCurrentUserAllowed(): boolean {
    // Controlla se l'utente è negli allowedUsers della lead padre (non solo della connessione)
    return this.fatherAllowedUsers.includes(this.user.id);
  }

  async onClick() {
    if (this.operationInfo) {
      // Seleziona la Lead corrispondente alla commessa prima di aprire il dialog
      await this.$store.dispatch('selectLead', { id: this.operationInfo?.id });
      this.editDialog = true;
    }
  }
}
